(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  (function () {
    var body = document.querySelector('[data-article-body]');
    var toc = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    if (!body || !toc || !list) return;

    var headings = body.querySelectorAll('h2, h3');
    if (headings.length < 2) return;

    function slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    }

    var used = {};
    headings.forEach(function (h) {
      var text = h.textContent.trim();
      if (!text) return;
      var id = h.id || slugify(text);
      if (used[id]) id = id + '-' + (++used[id]);
      used[id] = 1;
      h.id = id;

      var li = document.createElement('li');
      li.className = 'article__toc-item article__toc-item--' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'article__toc-link';
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    });

    toc.hidden = false;
  })();

  } catch(e) { console.error(e); }
})();
})();
